import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HomelandingComponent } from './homelanding.component';
import { HomelandingRoutingModule } from './homelanding-routing.module';
import { HomebannerModule } from '../shared/components/homebanner/homebanner.module';
import { BrandLogoModule } from '../shared/components/brand-logo/brand-logo.module';
import { AboutUsModule } from '../shared/components/about-us/about-us.module';
import { EventModule } from '../shared/components/event/event.module';
import { TestimonialModule } from '../shared/components/testimonial/testimonial.module';
import { FaqModule } from '../shared/components/faq/faq.module';
import { FooterModule } from '../shared/components/footer/footer.module';
import { HeaderModule } from '../shared/components/header/header.module';

@NgModule({
  declarations: [HomelandingComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    HomelandingRoutingModule,
    HomebannerModule,
    BrandLogoModule,
    AboutUsModule,
    EventModule,
    TestimonialModule,
    FaqModule,
    HeaderModule,
    FooterModule
  ]
})

export class HomelandingModule { }